import axios from 'axios';
import { PartInfo, CatalogResponse, CategoriesResponse, CatalogFilters } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5028/api';

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    timeout: 30000, // 30 seconds
    headers: {
        'Content-Type': 'application/json',
    },
});

if (process.env.NODE_ENV === 'development') {
    apiClient.interceptors.request.use(
        (config) => {
            console.log(`🚀 API Request: ${config.method?.toUpperCase()} ${config.url}`);
            return config;
        },
        (error) => {
            console.error('❌ API Request Error:', error);
            return Promise.reject(error);
        }
    );

    apiClient.interceptors.response.use(
        (response) => {
            console.log(`✅ API Response: ${response.status} ${response.config.url}`);
            return response;
        },
        (error) => {
            console.error('❌ API Response Error:', error.response?.status, error.response?.data);
            return Promise.reject(error);
        }
    );
}

export const uploadImage = async (file: File): Promise<PartInfo[]> => {
    const formData = new FormData();
    formData.append('image', file);

    const response = await axios.post<PartInfo[]>(`${API_BASE_URL}/parts/upload`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
};

export const getCatalog = async (
    page: number = 1, 
    pageSize: number = 10, 
    filters: CatalogFilters = {}
): Promise<CatalogResponse> => {
    const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
    });
    
    if (filters.search?.trim()) {
        params.append('search', filters.search.trim());
    }
    if (filters.category?.trim()) {
        params.append('category', filters.category.trim());
    }
    if (filters.subCategory?.trim()) {
        params.append('subCategory', filters.subCategory.trim());
    }
    
    const response = await axios.get<CatalogResponse>(`${API_BASE_URL}/catalog?${params}`);
    return response.data;
};

export const getCategories = async (): Promise<CategoriesResponse> => {
    const response = await axios.get<CategoriesResponse>(`${API_BASE_URL}/catalog/categories`);
    return response.data;
};

export const getPart = async (id: string): Promise<PartInfo> => {
    const response = await axios.get<PartInfo>(`${API_BASE_URL}/catalog/${id}`);
    return response.data;
};

export const getPartVariants = async (id: string): Promise<PartInfo[]> => {
    const response = await axios.get<PartInfo[]>(`${API_BASE_URL}/catalog/${id}/variants`);
    return response.data;
};
